import React from 'react';
import { Edit3, Zap, FileText, Globe } from 'lucide-react';
const volumes = [{
  title: 'VOLUME 1 · U6 and U7 (Part 1)',
  desc: 'First contact with rugby. Introductory games, ball and movement. 52 weeks of ready-to-use activities.'
}, {
  title: 'VOLUME 2 · U6 and U7 (Part 2)',
  desc: 'Consolidating the basics. Passing, support and mini assessment match. Year-end wrap-up and preparation for U8.'
}, {
  title: 'VOLUME 3 · U8 to U12 (Part 1)',
  desc: 'Youth foundations: introduction to contact. Safe tackling, rucks and collective play. Progression in weekly blocks.'
}, {
  title: 'VOLUME 4 · U8 to U12 (Part 2)',
  desc: 'Consolidating youth play. Match situations and assessment. Preparation for the junior stage.'
}, {
  title: 'VOLUME 5 · U13 (Part 1)',
  desc: 'Transition to structured rugby. Scrum, line-out and organized attack. Four-week blocks with progression.'
}, {
  title: 'VOLUME 6 · U13 (Part 2)',
  desc: 'Continuity of the U13 system. Set plays and annual assessment. Visual map of all 52 weeks.'
}, {
  title: 'VOLUME 7 · U14 (Part 1)',
  desc: 'Transition II: strength and tactical decision-making. Strategic kicking and organized defense. Ready sessions week by week.'
}, {
  title: 'VOLUME 8 · U14 (Part 2)',
  desc: 'Consolidating the U14 system. Structured match play and tactical adjustment. Year-end wrap-up by position.'
}, {
  title: 'VOLUME 9 · U15 (Part 1)',
  desc: 'Junior development: advanced attack. Linking phases and exiting your own zone. A complete game system.'
}, {
  title: 'VOLUME 10 · U15 (Part 2)',
  desc: 'High-performance junior rugby at U15. Set-piece plays and rush defense. Assessment and projection to U16.'
}, {
  title: 'VOLUME 11 · U16 and U17 (Part 1)',
  desc: 'High-performance amateur rugby. Defensive systems and structured attack. Preparation for official competition.'
}, {
  title: 'VOLUME 12 · U16 and U17 (Part 2)',
  desc: 'Consolidating the U16/U17 system. Advanced tactical adjustments. Closing the development stage.'
}, {
  title: 'VOLUME 13 · U19 and U23 (Part 1)',
  desc: 'Senior amateur and university rugby. Complete game system by unit. Preseason planning included.'
}, {
  title: 'VOLUME 14 · U19 and U23 (Part 2)',
  desc: 'Consolidating the senior system. Match tactics and real-time adjustment. The most complete system on the market.'
}];
const features = [{
  Icon: Edit3,
  label: 'Ready sessions by week and block'
}, {
  Icon: Zap,
  label: '"Open and Coach" system'
}, {
  Icon: FileText,
  label: 'Print-ready session sheets'
}, {
  Icon: Globe,
  label: 'Content built for rugby worldwide'
}];
export function TomosGrid() {
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-228" data-mp="3ulruyszdlryy">
      <div className="max-w-6xl mx-auto" data-id="element-229" data-mp="3uk6zn158m501">
        <div className="text-center mb-10 md:mb-14" data-id="element-230" data-mp="3ql7v3hnf4a94">
          <p className="text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-gray-500 mb-3" data-id="element-231" data-mp="3qileksijuker">
            What's inside
          </p>
          <h2 className="font-display uppercase text-gray-900 text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05]" data-id="element-232" data-mp="i2xh7nbz3xtq">
            The 14 complete{' '}
            <span className="text-neon-deep" data-id="element-233" data-mp="450let5cfvg4">volumes.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5 mb-10 md:mb-16" data-id="element-234" data-mp="9064zlb9wy11">
          {volumes.map(vol => <article key={vol.title} className="border-l-[3px] border-neon bg-gray-50 p-4 md:p-6 flex gap-3 md:gap-4" data-id="element-235" data-mp="3v979ziye2ovk">
              <span className="text-xl md:text-3xl leading-none" aria-hidden="true" data-id="element-236" data-mp="3hjdonam3emql">
                🏉
              </span>
              <div data-id="element-237" data-mp="3lh1l4i3fonkl">
                <h3 className="font-bold text-gray-900 text-[0.95rem] md:text-lg leading-snug mb-1.5" data-id="element-238" data-mp="37jwiyt6uc8um">
                  {vol.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-239" data-mp="3ci6bew16kvcj">
                  {vol.desc}
                </p>
              </div>
            </article>)}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 bg-ink p-6 md:p-8" data-id="element-240" data-mp="epo79ledr5ap">
          {features.map(({
          Icon,
          label
        }) => <div key={label} className="flex flex-col items-center text-center gap-2.5 md:gap-3" data-id="element-241" data-mp="4zcuragmrns7">
              <Icon className="text-acid" size={26} aria-hidden="true" data-id="element-242" data-mp="11hepr4mv58" />
              <span className="font-bold text-white text-[0.78rem] md:text-[0.95rem] leading-snug" data-id="element-243" data-mp="3r61jczdmzcbs">
                {label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}